import {BasicSymbol, SymbolStates} from "./BasicSymbol";
import {Reel} from "../Reel";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {XwaysHoarder2Statics} from "../../XwaysHoarder2Statics";
import {XwaysHoarder2GameAssets} from "../../XwaysHoarder2GameAssets";
import {SpineGSAPWrapper} from "../../utils/SpineGSAPWrapper";
import {SimpleReelModelSymbolPosition} from "../../../core/reel/simplereel/SimpleReelModel";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";


export class NormalSymbol extends BasicSymbol {
    public isScaled: boolean;
    private topHalfSprite: PIXI.Sprite;
    private bottomHalfSprite: PIXI.Sprite;
    private multiplierContainer: PIXI.Container;
    private mpTextTop: PIXI.BitmapText;
    private mpTextBottom: PIXI.BitmapText;
    private mpCollectiveValue: PIXI.BitmapText | null;
    private winEffect: TimelineSprite | null;
    private showTopHalf: boolean;
    private showBotHalf: boolean;

    // needs to be scaled, have a split container with two additonal sprites and two bitmaps
    constructor(symbolName: string, initState: SymbolStates, reel: Reel, symbolPosition: SimpleReelModelSymbolPosition) {
        super(symbolName, initState, reel, symbolPosition);

        this.load();
        this.getStateAnimation(initState);
        if (XwaysHoarder2.model.isRespinGameSpin && !XwaysHoarder2.model.data.reSpinTriggeredByAnotherLoot) {
            if (["M1", "M2", "M3", "M4", "M5", "M6", "L1", "L2", "L3", "L4", "L5"].includes(this.symbolName)) {
                this.showNoWinOverlay(XwaysHoarder2Statics.noWinTint, 0.01, 0.75, PIXI.BLEND_MODES.MULTIPLY, true).play(0);
            }
        }
        if (XwaysHoarder2.model.isRestore) {
            if (XwaysHoarder2.model.data.symbolSizes[this.reel.id][this.symID] >= 2) {
                if(XwaysHoarder2.model.data.symbolSizes[this.reel.id][this.symID]%2===0){
                    if(XwaysHoarder2.model.featureMap && XwaysHoarder2.model.featureMap.XW && XwaysHoarder2.model.featureMap.XW[this.reel.id][this.symID]===1){
                        let splitTimes: number = XwaysHoarder2.model.data.symbolSizes[this.reel.id][this.symID] / 2;
                        for (let i: number = 0; i < splitTimes; i++) {
                            this.getStateAnimation(SymbolStates.SPLIT);
                        }
                    }
                }
            }
        }
        // set first state as spin or normal
    }

    private _scaleDirection: string;

    get scaleDirection(): string {
        return this._scaleDirection;
    }

    set scaleDirection(value: string) {
        this._scaleDirection = value;
    }

    public getStateAnimation(state: SymbolStates): gsap.core.Timeline {
        let tl: gsap.core.Timeline = gsap.timeline();
        switch (state) {
            case SymbolStates.SPIN: // don't use this state when spinning out for normal symbol could be split or scaled
                tl.add(() => {
                    this.state = state;
                    this.setSpriteTexture("_spin");
                    this.moveToNormalLayer();
                });
                break;
            case SymbolStates.LANDING:
                tl.add(() => {
                    this.state = state;
                    this.setSpriteTexture("");
                })
                break;
            case SymbolStates.NO_WIN:
                tl.add(() => this.moveToNormalLayer());
                //  tl.add(this.showNoWinOverlay(XwaysHoarder2Statics.noWinTint, 0.3, 0.75, PIXI.BLEND_MODES.MULTIPLY, false));
                break;
            case SymbolStates.WIN:
                tl.add(() => {
                    this.state = state;
                    this.moveToWinLayer();
                }, 0);
                tl.add(this.playWinAnimation());
                break;
            case SymbolStates.REVEAL:
                break;
            case SymbolStates.REVERT:
                break;
            case SymbolStates.REMOVED:
                break;
            case SymbolStates.WIN_TOGGLE:
                break;
            case SymbolStates.STICKY:
                break;
            case SymbolStates.UNSTICKY:
                break;
            case SymbolStates.SPLIT: //only change sprite states
                tl.add(() => {
                    this.state = state;
                });
                tl.add(this.showSplitAnim());
                break;
            case SymbolStates.SCALED:  //only change sprite states
                tl.add(() => {
                    this.state = state;
                }, 0);
                tl.add(this.scaleAnimation());
                break;
            case SymbolStates.REVERSE_SCALED:
                tl.add(() => {
                    this.state = state;
                }, 0);
                tl.add(this.reverseScaleAnimation());
                break;
            default:
                tl.add(() => {
                    this.state = state;
                }, 0);
                this.moveToNormalLayer();
                this.setSpriteTexture("");
        }
        return tl;
    }


    public playThrashAnimation(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const symbolSkullAnim: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.RADIATION_SKULL));
        //symbolSkullAnim.scale.set(0.5, 0.5);
        symbolSkullAnim.position.set(this.mainSprite.position.x, this.mainSprite.position.y);
        symbolSkullAnim.visible = false;

        tl.add(() => {
            this.moveToLockOverlayLayer();
            this.view.addChild(symbolSkullAnim);
        }, 0);
        tl.add(() => {
            symbolSkullAnim.visible = true;
        }, 0.05);
        tl.add(SpineGSAPWrapper.createTimelineForAnimation(symbolSkullAnim, 0, "radiationSkull", false), 0);
        tl.add(this.showNoWinOverlay(XwaysHoarder2Statics.noWinTint, 0.45, 0.75, PIXI.BLEND_MODES.MULTIPLY, false), "<");
        tl.add(() => {
            this.moveToNormalLayer();
        }, ">");
        return tl;
    }

    public showSplitAnim(): gsap.core.Timeline {
        const symSplitTl: gsap.core.Timeline = gsap.timeline();
        if (!this.isSplitted && this.visualHeightStatus === 200 && !this.isScaled) {//first time split

            this.createTopSpriteTexture();
            this.topHalfSprite.scale.set(0.85, 0.85);

            this.createBottomSpriteTexture();
            this.bottomHalfSprite.scale.set(0.85, 0.85);

            this.visualHeightStatus = 2100;
            this.isSplitted = true;
            this.symbolSize = this.symbolSize * 2;

            symSplitTl.add(this.playSplitReelAnim(), 0);
            symSplitTl.to(this.mainSprite, {alpha: 0, duration: 0.18}, 0);
            symSplitTl.to([this.topHalfSprite.scale, this.bottomHalfSprite.scale], {x: 1, y: 1, duration: 0.18}, ">")


        } else if (this.isSplitted && this.visualHeightStatus === 2100 && !this.isScaled) {//second time and further splits
            //create mpTextTop and mpTextBottom or Update Them
            this.symbolSize = this.symbolSize * 2;
            const halfValue: number = JSON.parse(JSON.stringify(this.symbolSize)) / 2;

            this.isSplitted = true;


            if (halfValue >= 2) {
                symSplitTl.add(() => {
                    this.mpTextTop!.text = `${halfValue}x`;
                    this.mpTextBottom!.text = `${halfValue}x`;
                    this.mpTextTop!.position.set(XwaysHoarder2Statics.symbolWidth / 2 + this.mpTextTop!.textWidth / 2, XwaysHoarder2Statics.symbolHeight / 2 - this.mpTextTop!.textHeight);
                    this.mpTextBottom!.position.set(XwaysHoarder2Statics.symbolWidth / 2 + this.mpTextBottom!.textWidth / 2, XwaysHoarder2Statics.symbolHeight - this.mpTextBottom!.textHeight);

                    this.multiplierContainer.addChild(this.mpTextTop!, this.mpTextBottom!);
                }, 0);
            }
            symSplitTl.add(this.playSplitReelAnim(), 0);
            symSplitTl.to([this.mpTextTop, this.mpTextBottom], {alpha: 1, duration: 0.05}, 0.001);
            symSplitTl.to([this.mpTextTop.scale, this.mpTextBottom.scale], {x: 1, y: 1, duration: 0.05}, "<");

        }


        return symSplitTl;
    }

    public playWinAnimation(): gsap.core.Timeline {
        const winTL: gsap.core.Timeline = gsap.timeline();
        let halfEffect: TimelineSprite | null = null;
        let heightStatus: number = JSON.parse(JSON.stringify(this.visualHeightStatus));
        if (!this.isScaled && this.isSplitted) {
            heightStatus = 100;
        } else if (this.isScaled) {
            heightStatus = 100;
        }
        this.winEffect = new TimelineSprite(XwaysHoarder2.assetLoader.getTextures(`winGlow_${heightStatus}`));
        this.winEffect.name = `winEffect_${heightStatus}`;
        this.winEffect.anchor.set(0.5, 0.5);
        this.winEffect.blendMode = PIXI.BLEND_MODES.SCREEN;
        this.winEffect.position.set(0, 0);
        this.winEffect.hide();

        halfEffect = new TimelineSprite(XwaysHoarder2.assetLoader.getTextures(`winGlow_${heightStatus}`));
        halfEffect.name = `winEffect_${heightStatus}`;
        halfEffect.anchor.set(0.5, 0.5);
        halfEffect.blendMode = PIXI.BLEND_MODES.SCREEN;
        halfEffect.position.set(0, 0);
        halfEffect.hide();
        if (this.showBotHalf) {
            this.bottomHalfSprite.addChild(halfEffect);
            winTL.add(<gsap.core.Timeline><unknown>halfEffect!.getAnimationAutoShowHide(), 0);
        }


        //this.overlayContainer.addChild(this.winEffect);
        if (this.visualHeightStatus === 200 || (this.visualHeightStatus === 2100 && this.showTopHalf)) {
            heightStatus === 100 ? this.topHalfSprite.addChild(this.winEffect) : this.mainSprite.addChild(this.winEffect);
            winTL.add(<gsap.core.Timeline><unknown>this.winEffect.getAnimationAutoShowHide(), 0);
        }
        winTL.add(() => {
            //TODO maybe remove this if next mode is not normal
        });
        return winTL;
    }


    private reverseScaleAnimation(): gsap.core.Timeline {
        const unscaleTl: gsap.core.Timeline = gsap.timeline();
        if (!this.isSplitted && this.visualHeightStatus === 200) {
            this.mainSprite.anchor.y = 0.5;
            this.showBotHalf = false;
            this.showTopHalf = false;
            unscaleTl.to([this.bottomHalfSprite, this.topHalfSprite], {alpha: 0, duration: 0.1}, 0);
            unscaleTl.to(this.mainSprite.position, {y: 100, duration: 0.2}, 0);
            unscaleTl.to(this.mainSprite.scale, {y: 1, duration: 0.1}, 0);
            unscaleTl.to(this.mainSprite, {alpha: 1, duration: 0.1}, 0);
        } else if (this.isSplitted && this.visualHeightStatus === 2100) {

            unscaleTl.to([this.mpTextTop, this.mpTextBottom], {alpha: 1, duration: 0.2}, 0);
            unscaleTl.to(this.mpTextTop.position, {
                y: XwaysHoarder2Statics.symbolHeight / 2 - this.mpTextTop!.textHeight,
                duration: 0.2
            }, 0);
            unscaleTl.to(this.mpTextBottom.position, {
                y: XwaysHoarder2Statics.symbolHeight - this.mpTextBottom!.textHeight,
                duration: 0.2
            }, 0);
            unscaleTl.to(this.mpCollectiveValue!, {alpha: 0, duration: 0.1}, 0);


            if (this.symID === 0) {
                this.bottomHalfSprite.anchor.y = 0.5;
                unscaleTl.to(this.bottomHalfSprite.scale, {duration: 0.2, y: 1}, 0);
                unscaleTl.to(this.bottomHalfSprite.position, {duration: 0.2, y: 150}, 0);
                unscaleTl.to(this.bottomHalfSprite, {alpha: 1, duration: 0.05}, 0);
            } else if (this.symID === 2) {
                this.topHalfSprite.anchor.y = 0.5;
                unscaleTl.to(this.topHalfSprite.scale, {duration: 0.2, y: 1}, 0);
                unscaleTl.to(this.topHalfSprite.position, {duration: 0.2, y: 50}, 0);
                unscaleTl.to(this.topHalfSprite, {alpha: 1, duration: 0.05}, 0);
                this.showTopHalf = false;

            } else if (this.symID === 1) {//use direction

                if (this._scaleDirection === "north") {
                    this.bottomHalfSprite.anchor.y = 0.5;
                    unscaleTl.to(this.bottomHalfSprite.scale, {duration: 0.2, y: 1}, 0);
                    unscaleTl.to(this.bottomHalfSprite, {alpha: 1, duration: 0.05}, 0);
                    unscaleTl.to(this.topHalfSprite.position, {y: 50, duration: 0.2}, 0);
                    unscaleTl.to(this.bottomHalfSprite.position, {y: 150, duration: 0.2}, 0);
                } else if (this._scaleDirection === "south") {
                    this.topHalfSprite.anchor.y = 0.5;
                    unscaleTl.to(this.topHalfSprite.scale, {duration: 0.2, y: 1}, 0);
                    unscaleTl.to(this.topHalfSprite, {alpha: 1, duration: 0.05}, 0);
                    unscaleTl.to(this.topHalfSprite.position, {y: 50, duration: 0.2}, 0);
                    unscaleTl.to(this.bottomHalfSprite.position, {y: 150, duration: 0.2}, 0);
                }
                this.showBotHalf = true;
                this.showTopHalf = true;
            }

        }

        return unscaleTl;
    }

    private scaleAnimation(): gsap.core.Timeline {
        this.isScaled = true;
        const scaleTl: gsap.core.Timeline = gsap.timeline();
        //consider adding direction to the middle symbol

        if (!this.isSplitted && this.visualHeightStatus === 200) {
            if (this.symID === 0) {
                this.mainSprite.anchor.y = 0;
                this.mainSprite.position.y -= 100;
                this.createTopSpriteTexture();
                this.showBotHalf = false;

            } else if (this.symID === 2) {
                this.mainSprite.anchor.y = 1;
                this.mainSprite.position.y += 100;
                this.createBottomSpriteTexture();
                this.showTopHalf = false;

            } else if (this.symID === 1) {//use direction
                if (this._scaleDirection === "north") {
                    this.mainSprite.anchor.y = 0;
                    this.mainSprite.position.y -= 100;
                    this.createTopSpriteTexture();
                    scaleTl.to(this.mainSprite, {y: -100, duration: 0.15, ease: "power2.out."}, 0);
                    scaleTl.to(this.topHalfSprite, {y: -50, duration: 0.10, ease: "power2.out."}, 0);
                    this.showBotHalf = false;


                } else if (this._scaleDirection === "south") {
                    this.mainSprite.anchor.y = 1;
                    this.mainSprite.position.y += 100;
                    this.createBottomSpriteTexture();
                    scaleTl.to(this.mainSprite, {y: 300, duration: 0.15, ease: "power2.out."}, 0);
                    scaleTl.to(this.bottomHalfSprite, {y: 250, duration: 0.2, ease: "power2.out."}, 0);
                    this.showTopHalf = false;

                }
            }
            scaleTl.to(this.mainSprite.scale, {duration: 0.2, y: 0.5, ease: "power2.out."}, 0);
            scaleTl.to(this.mainSprite, {alpha: 0, duration: 0.1}, 0.1);

        } else if (this.isSplitted && this.visualHeightStatus === 2100) {

            this.mpCollectiveValue = new PIXI.BitmapText("", {
                fontName: XwaysHoarder2GameAssets.NUMBERS_MULTIPLIER,
                fontSize: 32,
            });
            this.mpCollectiveValue.name = "mpCollective";
            this.mpCollectiveValue.anchor = new PIXI.Point(0.5, 0.5);
            this.mpCollectiveValue.scale.set(0.85, 0.85);


            scaleTl.add(() => {
                this.mpCollectiveValue!.text = `${this.symbolSize}x`;
                if (this.showTopHalf) {
                    this.mpCollectiveValue!.position.set(XwaysHoarder2Statics.symbolWidth / 2 + this.mpCollectiveValue!.width / 2, XwaysHoarder2Statics.symbolHeight / 2 - this.mpCollectiveValue!.height);
                } else {
                    this.mpCollectiveValue!.position.set(XwaysHoarder2Statics.symbolWidth / 2 + this.mpCollectiveValue!.width / 2, XwaysHoarder2Statics.symbolHeight - this.mpCollectiveValue!.height);
                }
                this.multiplierContainer.addChild(this.mpCollectiveValue!);
            }, 0);

            if (this.symID === 0) {
                this.bottomHalfSprite.anchor.y = 0;
                this.bottomHalfSprite.position.y = 100;
                scaleTl.to(this.bottomHalfSprite.scale, {duration: 0.2, y: 0, ease: "power2.out."}, 0);
                // scaleTl.to(this.bottomHalfSprite.position, {duration: 0.2, y: 100}, 0);
                scaleTl.to(this.bottomHalfSprite, {alpha: 0, duration: 0.1}, "<0.1");
                scaleTl.to(this.mpTextBottom.position, {y: 80, duration: 0.2}, 0);
                scaleTl.to(this.mpCollectiveValue.position, {y: 61, duration: 0.2}, "<");

                this.showBotHalf = false;
            } else if (this.symID === 2) {
                this.topHalfSprite.anchor.y = 1;
                this.topHalfSprite.position.y = 100;
                scaleTl.to(this.topHalfSprite.scale, {duration: 0.2, y: 0, ease: "power2.out."});
                //   scaleTl.to(this.topHalfSprite.position, {duration: 0.2, y: 100}, 0);
                scaleTl.to(this.topHalfSprite, {alpha: 0, duration: 0.1}, "<0.1");
                scaleTl.to(this.mpTextTop.position, {y: 100, duration: 0.2}, 0);
                scaleTl.to(this.mpCollectiveValue.position, {y: 161, duration: 0.2}, "<");
                this.showTopHalf = false;
            } else if (this.symID === 1) {//use direction
                if (this._scaleDirection === "north") {
                    this.bottomHalfSprite.anchor.y = 0;
                    this.bottomHalfSprite.position.y -= 50;
                    scaleTl.to(this.bottomHalfSprite.scale, {duration: 0.2, y: 0, ease: "power2.out."});
                    scaleTl.to(this.bottomHalfSprite, {alpha: 0, duration: 0.1}, "<0.1");
                    scaleTl.to(this.topHalfSprite.position, {y: -50, duration: 0.2}, 0);
                    scaleTl.to(this.bottomHalfSprite.position, {y: 0, duration: 0.2}, 0);
                    scaleTl.to(this.mpTextBottom.position, {duration: 0.2, y: -30}, "<");
                    scaleTl.to(this.mpCollectiveValue.position, {duration: 0.2, y: -37}, "<");
                    this.showBotHalf = false;
                } else if (this._scaleDirection === "south") {
                    this.topHalfSprite.anchor.y = 1;
                    this.topHalfSprite.position.y += 50;
                    scaleTl.to(this.topHalfSprite.scale, {duration: 0.2, y: 0, ease: "power2.out."});
                    scaleTl.to(this.topHalfSprite, {alpha: 0, duration: 0.1}, "<0.1");
                    scaleTl.to(this.topHalfSprite.position, {y: 200, duration: 0.2}, 0);
                    scaleTl.to(this.bottomHalfSprite.position, {y: 250, duration: 0.2}, 0);
                    scaleTl.to(this.mpTextTop.position, {duration: 0.2, y: 200}, "<");
                    scaleTl.to(this.mpCollectiveValue.position, {duration: 0.2, y: 261}, "<");
                    this.showTopHalf = false;
                }
            }
            scaleTl.to(this.mpCollectiveValue!, {alpha: 1, duration: 0.1}, 0.1);
            scaleTl.to(this.mpCollectiveValue!.scale, {x: 1, y: 1, duration: 0.1}, "<");
            scaleTl.to([this.mpTextTop!, this.mpTextBottom!], {alpha: 0, duration: 0.1}, 0);
        }
        return scaleTl;
    }

    private load(): void {
        this.topHalfSprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this.topHalfSprite.name = "topHalfSprite";
        this.topHalfSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.topHalfSprite.anchor.set(0.5, 0.5);
        this.topHalfSprite.visible = false;

        this.bottomHalfSprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this.bottomHalfSprite.name = "bottomHalfSprite";
        this.bottomHalfSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.bottomHalfSprite.anchor.set(0.5, 0.5);
        this.bottomHalfSprite.visible = false;

        this.mainSpriteContainer.addChild(this.topHalfSprite, this.bottomHalfSprite, this.mainSprite);

        this.mainSpine = null;
        this.multiplierContainer = new PIXI.Container();
        this.multiplierContainer.name = "multiplierContainer";

        //winHighlight
        this.winEffect = null;

        //use bitmap texts when it splits
        this.mpTextTop = new PIXI.BitmapText("", {
            fontName: XwaysHoarder2GameAssets.NUMBERS_MULTIPLIER,
            fontSize: 32,
        });
        this.mpTextTop.name = "mpTextTop";
        this.mpTextTop.anchor = new PIXI.Point(0.5, 0.5);
        this.mpTextTop.scale.set(0.85, 0.85);
        this.mpTextTop.alpha = 0;

        this.mpTextBottom = new PIXI.BitmapText("", {
            fontName: XwaysHoarder2GameAssets.NUMBERS_MULTIPLIER,
            fontSize: 32,
        });
        this.mpTextBottom.name = "mptextBottom";
        this.mpTextBottom.anchor = new PIXI.Point(0.5, 0.5);
        this.mpTextBottom.scale.set(0.85, 0.85);
        this.mpTextBottom.alpha = 0;


        this.visualHeightStatus = 200;
        this.isSticky = false;
        this.isOldSym = false; //doesnt matter in restore
        this.symbolHeight = 1;//no of space it fills in terms of symbol count in a reel
        this.splitAnimOn = false;
        this.isSplitted = false;
        this.symbolSize = 1;//multiplier counter
        this.noWinOverlay = null; //create according to size
        this.isScaled = false;
        this.showBotHalf = false;
        this.showTopHalf = false;


        this.view.addChild(this.mainSpriteContainer, this.multiplierContainer, this.overlayContainer);
    }

    private playSplitReelAnim(): gsap.core.Timeline {
        const splitReelTL: gsap.core.Timeline = gsap.timeline();
        const splitReelSpine: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.SPLIT_REEL));
        splitReelSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        splitReelTL.add(() => {
            this.view.addChild(splitReelSpine);
        }, 0.005);
        splitReelTL.add(SpineGSAPWrapper.createTimelineForAnimation(splitReelSpine, 0, "1x1", false), 0);
        splitReelTL.add(() => {
            this.view.removeChild(splitReelSpine);
        }, ">");

        return splitReelTL;
    }

    private createTopSpriteTexture(): void {
        this.topHalfSprite.texture = XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.getSymbolStateTexturePath(this.symbolName, "_0_5x1"))[0];
        this.topHalfSprite.anchor.set(0.5, 0.5);
        this.topHalfSprite.x = (this.topHalfSprite.width / 2);
        this.topHalfSprite.y = XwaysHoarder2Statics.symbolHeight * 0.25;
        this.topHalfSprite.scale.set(1, 1);
        this.topHalfSprite.visible = true;
        this.showTopHalf = true;

    }

    private createBottomSpriteTexture(): void {
        this.bottomHalfSprite.texture = XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.getSymbolStateTexturePath(this.symbolName, "_0_5x1"))[0];
        this.bottomHalfSprite.anchor.set(0.5, 0.5);
        this.bottomHalfSprite.x = (this.bottomHalfSprite.width / 2);
        this.bottomHalfSprite.y = 150;
        this.bottomHalfSprite.scale.set(1, 1);
        this.bottomHalfSprite.visible = true;
        this.showBotHalf = true;
    }
}